// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_da-0";
export var actionModalContentContainer = "_da-1";
export var createTagButton = "_da-2";
export var footerContainer = "_da-7";
export var fullWidthDivider = "_da-3";
export var hasCreateTagButton = "_da-4";
export var noCreateTagButton = "_da-5";
export var tagsContainer = "_da-6";
export var tagsModalContentContainer = "_da-8";